import { AppDispatch } from '@store/index';
import { notification } from 'antd';
import Axios from '../../../axios/axios';

export const updateUser =
    (
        userId: number,
        email: string,
        name: string,
        lastName: string,
        startShiftTime: string,
        endShiftTime: string,
        // passwd: string,
        photo: string,
        phoneNumber: string,
        franchiseId: number,
        isActive: number,
    ) =>
    async (dispatch: AppDispatch) => {
        dispatch({
            type: 'LOADING_UPDATE_USER',
            payload: true,
        });

        try {
            await Axios.put('/users', {
                userId,
                email,
                name,
                lastName,
                startShiftTime,
                endShiftTime,
                photo,
                // passwd,
                phone: phoneNumber,
                franchiseId,
                isActive,
                workPosition: 'employee',
            });
            notification.success({
                message: 'Usuario actualizado',
                description: '¡El usuario fue actualizado correctamente!',
            });
            dispatch({
                type: 'LOADING_UPDATE_USER',
                payload: false,
            });
        } catch (error) {
            notification.error({
                message: 'Ocurrio un error.',
                description: '¡No se pudo actualizar el usuario!',
            });
            dispatch({
                type: 'LOADING_UPDATE_USER',
                payload: false,
            });
        }
    };
